import type { WorkOrderPriceStatusEnum } from 'gql/graphql';

export interface IOthersData {
    id: number | string;
    name: string;
    calculatingType: string;
    calculatingTypeValue: number | null;
    chapter?: string;
    limits?: { costLimit: number; totalRemainderCost: number; season: { id: number; year: number } }[];
    status?: WorkOrderPriceStatusEnum;
    contractOtherCostId: number;
    parentId: number;
    objectId: number;
}

export interface IOthersObject {
    id: number;
    constructionType: {
        id: number;
    };
    name: string;
    parentId?: number | null;
}

export const enum CalculatingType {
    PERCENT = 'PERCENT',
    CALCULATION = 'CALCULATION',
}

export const TYPE_CONST: Record<string, string> = {
    CALCULATION: 'Расчет',
    PERCENT: '',
};

export const CHAPTER_CONST: Record<string, string> = {
    CHAPTER9: 'Глава 9',
};

export interface ICheckedObjs {
    [key: number | string]: {
        [key: number | string]: any;
    };
}
export interface IOtherValues {
    [key: string]: {
        [key: string]: any;
    };
}
